import React from 'react';
import styled from "@emotion/styled";
import { Box, TextField, InputAdornment } from '@mui/material';
import CalenderIcon from "../assets/icons/calendar-dash.svg";
import HolidayDate from "./DateSelectDialog";
import ErrorMsg from './ErrorMsg';

import { tokens } from "../theme";
const TextLabel = styled(Box)({
    fontSize: '1rem',
    lineHeight: '1.5rem',
    color: tokens.textMuted,
    marginBottom: "4px"
});
  
  const InputBoxStyle = {
    height: '3rem',
    borderRadius: '10px',
    fontWeight:400,
    fontSize: '1rem',
    lineHeight: '1.5rem',
    color:'#2A1D22CC'
}

const DateField = ({ label, value,fullwidth, isDialogOpen, openDialog, closeDialog, onSelect , disabled, validation, past, disableFuture, openTo, noMargin, height }) => {
  return (
    // noMargin/height for callers that lay the field out themselves — a grid
    // supplies its own gap, and 2.75rem is the height the wizards use.
    <Box sx={{ width: fullwidth?'100%':'48%',marginBottom: noMargin ? 0 : '1.125rem' }}>
      {label ? <TextLabel>{label}</TextLabel> : null}
      <TextField
        placeholder="YYYY-MM-DD"
        value={value || ''}
        onClick={openDialog}
        variant="outlined"
        disabled={disabled}
        fullWidth
        InputProps={{
          readOnly: true,
          endAdornment: (
            <InputAdornment position="end">
              <img src={CalenderIcon} alt="Calendar" />
            </InputAdornment>
          ),
        }}
        sx={{
          "& .MuiInputBase-root": { ...InputBoxStyle, ...(height ? { height } : {}) },
          "& .MuiOutlinedInput-notchedOutline": {
            border: `1px solid ${tokens.border}`
          },
          "& .MuiInputBase-input.Mui-disabled": {
            WebkitTextFillColor: "#2A1D22",
            color: "#2A1D22",
            opacity: 1,
          },
        }}
      />
      <ErrorMsg>{validation}</ErrorMsg>
      <HolidayDate open={isDialogOpen} onClose={closeDialog} onSelect={onSelect} past={past}
        disableFuture={disableFuture} openTo={openTo} value={value}/>
    </Box>
  );
};

export default DateField;
